import React, { useState, useContext } from "react";
import { CustomModal } from "../../../components/CustomModal";
import ProfessionsModal from "./modals/professionsModal/ProfessionsModal";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getStaticExpertFields, updateExpert } from "../../../service/api";
import ExpertProfessionsContext from "../../../context/expertProffessionsContext";
import ExpertDataContext from "../../../context/expertDataContext";

function Professions({ data }) {
  const client = useQueryClient();
  const staticsExpertFieldsQuery = useQuery(
    ["staticsExpertFields"],
    getStaticExpertFields
  );

  const {
    comprehensiveProfessionsIds,
    farmingIds,
    greenHouseIds,
    liveStockIds,
    veterinaryIds,
    resetProfessions
  } = useContext(ExpertProfessionsContext);

  const { expertData, resetExpertDataContext } = useContext(ExpertDataContext);
const [loading,setLoading] = useState()
  const [openModal, setOpenModal] = useState(false);
  const [openMiniModal, setOpenMiniModal] = useState(false);

  let w = document.documentElement.clientWidth || window.innerWidth;
  const otherProfessions = data?.otherProfessions;
  //cp
  const comprehensiveProfessions = data?.professions
    .filter(
      (item) => item?.categoryEN === "PROFESSIONS_COMPREHENSIVE_PROFESSIONS"
    )
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  //farming

  const farming = data?.professions
    .filter((item) => item?.categoryEN === "PROFESSIONS_FARMS_AND_GARDENS")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  // greenHouse
  const greenHouse = data?.professions
    .filter((item) => item?.categoryEN === "PROFESSIONS_GREENHOUSE")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  // defaultLiveStock
  const liveStock = data?.professions
    .filter((item) => item?.categoryEN === "PROFESSIONS_LIVESTOCK_POULTRY")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  // defaultVeterinary
  const veterinary = data?.professions
    .filter((item) => item?.categoryEN === "PROFESSIONS_VETERINARY_MEDICINE")
    .map((item) => {
      return { label: item?.name, value: item?.id };
    });

  const stringMaker = (array) => {
    return array?.join("/");
  };

  const modalHandler = () => {
    resetExpertDataContext()
    resetProfessions()
    if (w > 640) {
      setOpenModal(true);
    } else if (w <= 640) {
      setOpenMiniModal(true);
    }
  };

  const updateMutation = useMutation(updateExpert,{
    onMutate:()=>{
setLoading(true)
    },
    onSuccess: () => {
      client.invalidateQueries(["expertData"]);
      setOpenModal(false);
      setOpenMiniModal(false);
      setLoading(false)
    },
  })


  const onOk = () => {

    const cpIds = comprehensiveProfessionsIds ? comprehensiveProfessionsIds : comprehensiveProfessions?.map((item) => item?.value)
    const fdIds = farmingIds ? farmingIds : farming?.map((item) => item?.value)
    const ghIds = greenHouseIds ? greenHouseIds : greenHouse?.map((item) => item?.value)
    const lsIds = liveStockIds ? liveStockIds : liveStock?.map((item) => item?.value)
    const vIds = veterinaryIds ? veterinaryIds : veterinary?.map((item) => item?.value)


    let mutationObject = {
      professionsIds: [
        ...cpIds,
        ...fdIds,
        ...ghIds,
        ...lsIds,
        ...vIds,
      ],
    };

    
    if(expertData !== {}) {
      mutationObject = {...mutationObject, ...expertData}
    }

    updateMutation.mutate(
      mutationObject,
    
    );
  };

  return (
    <div
  
      className=" w-1/2 relative max-lg:w-full "
    >
    
      <div
        onClick={modalHandler}
        className="flex flex-col gap-5 bg-white text-right font-body p-6 rounded-xl h-full hover:brightness-90 hover:cursor-pointer hover:shadow-lg"
      >
        <h2 className="text-[#005AC7] text-xl font-bold text-start max-lg:text-[0.875rem]">
          حرفه‌ها
        </h2>
        <section className="flex flex-col gap-3">
          <div className="flex flex-row gap-2">
            <p className="font-bold whitespace-nowrap">حرف جامع :</p>
            <p className="flex flex-row  flex-wrap">
              {stringMaker(
                data?.professions
                  ?.filter(
                    (e) =>
                      e?.categoryEN === "PROFESSIONS_COMPREHENSIVE_PROFESSIONS"
                  )
                  ?.map((e) => e.name)
              )}
            </p>
          </div>
          <div className="flex flex-row gap-2">
            <p className="font-bold whitespace-nowrap">زراعت و باغ :</p>
            <p className="flex flex-row  flex-wrap">
              {stringMaker(
                data?.professions
                  ?.filter(
                    (e) => e?.categoryEN === "PROFESSIONS_FARMS_AND_GARDENS"
                  )
                  ?.map((e) => e.name)
              )}
            </p>
          </div>
          <div className="flex flex-row gap-2">
            <p className="font-bold whitespace-nowrap">گلخانه :</p>
            <p className="flex flex-row  flex-wrap">
              {stringMaker(
                data?.professions
                  ?.filter((e) => e?.categoryEN === "PROFESSIONS_GREENHOUSE")
                  ?.map((e) => e.name)
              )}
            </p>{" "}
          </div>
          <div className="flex flex-row gap-2">
            <p className="font-bold whitespace-nowrap">دام و طیور :</p>
            <p className="flex flex-row  flex-wrap">
              {stringMaker(
                data?.professions
                  ?.filter(
                    (e) => e?.categoryEN === "PROFESSIONS_LIVESTOCK_POULTRY"
                  )
                  ?.map((e) => e.name)
              )}
            </p>{" "}
          </div>
          <div className="flex flex-row gap-2">
            <p className="font-bold">دامپزشکی :</p>
            <p className="flex flex-row  flex-wrap">
              {stringMaker(
                data?.professions
                  ?.filter(
                    (e) => e?.categoryEN === "PROFESSIONS_VETERINARY_MEDICINE"
                  )
                  ?.map((e) => e.name)
              )}
            </p>{" "}
          </div>
          <div className="flex flex-row gap-2">
            <p className="font-bold">سایر حرفه ها :</p>
            <p className="flex flex-row  flex-wrap">
              {otherProfessions ? otherProfessions : "-"}
            </p>{" "}
          </div>
        </section>
      </div>
      <div>
        {openModal && (
          <CustomModal
            onOk={onOk}
            loading={loading}
            size={"56vw"}
            handleCancel={() => setOpenModal(false)}
            visible={openModal}
          >
            <ProfessionsModal
              data={data}
              professionsOptions={
                staticsExpertFieldsQuery?.data?.PROFESSIONS || null
              }
              defaults={{
                defaultCP: comprehensiveProfessions,
                defaultFarming: farming,
                defaultGreenHouse: greenHouse,
                defaultLiveStock: liveStock,
                defaultVeterinary: veterinary,
              }}
            />
          </CustomModal>
        )}
      </div>
      <div>
        {openMiniModal && (
          <CustomModal
            onOk={onOk}
            loading={loading}
            size={"100vw"}
            handleCancel={() => setOpenMiniModal(false)}
            visible={openMiniModal}
          >
            <ProfessionsModal
              data={data}
              professionsOptions={
                staticsExpertFieldsQuery?.data?.PROFESSIONS || null
              }
              defaults={{
                defaultCP: comprehensiveProfessions,
                defaultFarming: farming,
                defaultGreenHouse: greenHouse,
                defaultLiveStock: liveStock,
                defaultVeterinary: veterinary,
              }}
            />
          </CustomModal>
        )}
      </div>
    </div>
  );
}

export default Professions;
